import {negate} from 'ramda'

const searchFilters = [
  'filter.order.createdByExternalCompanyId',
  'filter.order.tradePartnerExternalCompanyId',
  'filter.invoicedCompany.externalCompanyId',
]

export const prepareFilterParams = filters => {
  const updatedFilters = {
    'filter.externalId': [],
  }

  Object.keys(filters).forEach(key => {
    if (key.startsWith('filter.externalId')) {
      // moving all filters that starts with external id to new filter filter.externalId
      // splitting to retrieve the external id value and pushing to filter.externalId array (value:label)
      updatedFilters['filter.externalId'].push(...filters[key].map(filter => filter.split(':')[0]))
    } else {
      updatedFilters[key] = filters[key]
    }
    if (searchFilters.some(searchFilter => key === searchFilter)) {
      updatedFilters[key] = filters[key].map(filter => filter.split(':')[0])
    }
  })

  if (updatedFilters['filter.externalId'].length === 0) delete updatedFilters['filter.externalId']

  // setting only one value for productType as string, when either one of the product type is selected
  if (
    updatedFilters['filter.order.productType'] &&
    updatedFilters['filter.order.productType'].length === 1
  ) {
    const [first] = updatedFilters['filter.order.productType']
    updatedFilters['filter.order.productType'] = first
  }

  if (updatedFilters['filter.totals.totalAmountInclVAT.from'])
    updatedFilters['filter.totals.totalAmountInclVAT.from'] = negate(
      updatedFilters['filter.totals.totalAmountInclVAT.from']
    )
  if (updatedFilters['filter.totals.totalAmountInclVAT.to'])
    updatedFilters['filter.totals.totalAmountInclVAT.to'] = negate(
      updatedFilters['filter.totals.totalAmountInclVAT.to']
    )

  return updatedFilters
}
